import m from "./../../../dist/es2015/locales/nl_NL.js";
export const am5locales_nl_NL = m;